import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ContactIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ContactIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: ContactIconProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      className={className}
      {...props}
      fill="none"
    >
      <Path
        d="M10.79 1.833H5.21c-.665 0-1.204.555-1.204 1.24v9.853c0 .685.54 1.24 1.205 1.24h5.579c.665 0 1.205-.555 1.205-1.24V3.073c0-.685-.54-1.24-1.205-1.24z"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName.replace("fill-", "stroke-")}
      />
      <Path
        d="M8 12.516a.346.346 0 100-.693.346.346 0 000 .693zM6.668 3.515h2.663"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName.replace("fill-", "stroke-")}
      />
    </Svg>
  );
}

export default ContactIcon;
